import {
    DOCTOR_PAYOUT_LIST_REQUEST,
    DOCTOR_PAYOUT_LIST_SUCCESS,
    DOCTOR_PAYOUT_LIST_FAIL,
    DOCTOR_PAYOUT_CREATE_REQUEST,
    DOCTOR_PAYOUT_CREATE_SUCCESS,
    DOCTOR_PAYOUT_CREATE_FAIL,
    DOCTOR_PAYOUT_UPDATE_REQUEST,
    DOCTOR_PAYOUT_UPDATE_SUCCESS,
    DOCTOR_PAYOUT_UPDATE_FAIL,
} from '../actions/types';

const initialState = {
    loading: false,
    payoutRecords: [],
    error: null,
};

export const doctorPayoutReducer = (state = initialState, action) => {
    switch (action.type) {
        // --- LIST CASES ---
        case DOCTOR_PAYOUT_LIST_REQUEST:
            return { ...state, loading: true };
        case DOCTOR_PAYOUT_LIST_SUCCESS:
            return { loading: false, payoutRecords: action.payload, error: null };
        case DOCTOR_PAYOUT_LIST_FAIL:
            return { ...state, loading: false, error: action.payload };

        // --- CREATE CASES ---
        case DOCTOR_PAYOUT_CREATE_REQUEST:
            // Set loading to true, but don't clear existing records
            return { ...state, loading: true };
        case DOCTOR_PAYOUT_CREATE_SUCCESS:
            // Add the newly created record to the existing list immutably
            return {
                ...state,
                loading: false,
                payoutRecords: [...state.payoutRecords, action.payload],
            };
        case DOCTOR_PAYOUT_CREATE_FAIL:
            return { ...state, loading: false, error: action.payload };

        // --- UPDATE CASES ---
        case DOCTOR_PAYOUT_UPDATE_REQUEST:
            // Set loading to true, but don't clear existing records
            return { ...state, loading: true };
        case DOCTOR_PAYOUT_UPDATE_SUCCESS:
            // Find the record in the existing list and replace it with the updated one
            return {
                ...state,
                loading: false,
                payoutRecords: state.payoutRecords.map((record) =>
                    record._id === action.payload._id ? action.payload : record
                ),
            };
        case DOCTOR_PAYOUT_UPDATE_FAIL:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
};